export default __webpack_public_path__ + "static/media/Grams.efb16961.jpg";